"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.chipVars = exports.chipCommon = void 0;
var _Text = require("../Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var chipCommon = exports.chipCommon = ["padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var chipVars = exports.chipVars = (0, _initVars.default)({
  applied: chipCommon,
  variables: [{
    key: "chipSelectedColor",
    canHaveColor: true
  }, {
    key: "chipSelectedContentColor",
    canHaveColor: true
  }]
});
var chipStyles = function chipStyles(theme) {
  return {
    variables: chipVars.styles,
    root: _objectSpread({
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      background: "transparent",
      borderRadius: 2,
      transition: "background 250ms ease-in-out, border-color 250ms ease-in-out, color 250ms ease-in-out",
      fontFamily: theme.typography.fontFamily,
      letterSpacing: theme.typography.letterSpacing,
      textTransform: "uppercase",
      color: theme.colors.baseContrast100,
      "& *": {
        transition: "color 250ms ease-in-out, fill 70ms ease-in-out",
        color: theme.colors.baseContrast100,
        fill: theme.colors.baseContrast100
      }
    }, (0, _Text.setTextCssVars)({
      fontSize: theme.typography.fontSize,
      fontWeight: 500
    })),
    small: {
      height: theme.spacing.base * 3,
      padding: [0, theme.spacing.base * 1.2]
    },
    medium: {
      height: theme.spacing.base * 4,
      padding: [0, theme.spacing.base * 1.8]
    },
    large: {
      height: theme.spacing.base * 4.5,
      padding: [0, theme.spacing.base * 2]
    },
    input: {
      position: "absolute",
      width: 1,
      height: 1,
      opacity: 0
    },
    inputRelated: {
      cursor: "pointer",
      userSelect: "none",
      webkitUserSelect: "none",
      "&:has(input:checked)": {
        background: chipVars.get("chipSelectedColor"),
        color: chipVars.get("chipSelectedContentColor"),
        "& *": {
          color: chipVars.get("chipSelectedContentColor"),
          fill: chipVars.get("chipSelectedContentColor")
        }
      },
      "&:has(input:disabled)": {
        cursor: "not-allowed",
        color: theme.colors.baseContrast040
      }
    }
  };
};
var useStylesChip = (0, _createUseStyles.default)(chipStyles, {
  name: "Chip"
});
var _default = exports.default = useStylesChip;